<script>

    import layer from "@/mixins/mapboxLayer"

    export default{

        mixins:[layer],
        
        name:"course",

        data(){
            return {
            }
        },

        computed:{
            geoJSON:function(){
                return this.$store.getters.courses;
            },
        },


        watch:{
            geoJSON:function(){
                this.animateLine(4, false)
            }
        },

        methods:{

        },
        
        style: function () {
            return {
                "id": "percurso",
                "type": "line",
                // "source": "percurso",
                "layout": {
                    "line-join": "round",
                    "line-cap": "round"
                },
                "paint": {
                    
                    "line-emissive-strength": 1,
                    "line-dasharray": {
                        "base": 1,
                        "stops": [
                            [11, [4, 0]],
                            [12, [1, 1]]
                        ]
                    },
                    "line-color": {
                        "base": 1,
                        "stops": [
                            [9, '#333333'],
                            [11, '#ff8f00']
                        ]
                    },
                    "line-width": {
                        "base": 1,
                        "stops": [
                            [9, 1],
                            [15, 3],
                        ]
                    },
                    "line-join": "round",
                    "line-trim-color": "#ff8f00",
                    "line-opacity": {
                        "base": 1,
                        "stops": [
                            [9, 0.2],
                            [11, 1]
                        ]
                    },
                }
            }
        }

    }


</script>